import axios from "axios";
import "../config/axios";

const publicApi = axios.create({
  baseURL: axios.defaults.baseURL,
  timeout: axios.defaults.timeout,
  headers: {
    "Content-Type": "application/json"
  }
});

export default publicApi;
